// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SHOW_FULL_ANSWER = "Zobraz celou odpov\u011b\u010f";
